import L from 'leaflet';
import { escapeHtml } from './mapTooltip';

/**
 * Shared marker + cluster look for every Leaflet map (styles in
 * src/app/globals.css under `.cl-map-pin` / `.cl-map-cluster`): a white-edged
 * teardrop pin and a round cluster bubble, both colored per call.
 */
export type PinTone = 'emerald' | 'amber' | 'indigo' | 'rose' | 'slate';

export const PIN_TONES: Record<PinTone, string> = {
  emerald: '#10b981',
  amber: '#f59e0b',
  indigo: '#6366f1',
  rose: '#f43f5e',
  slate: '#64748b',
};

/** Tooltip offset that clears the pin body (pin tip sits on the coordinate). */
export const PIN_TOOLTIP_OFFSET: [number, number] = [0, -38];

export const createPinIcon = ({
  tone = 'emerald',
  color,
  label,
}: { tone?: PinTone; color?: string; label?: string | number } = {}): L.DivIcon =>
  L.divIcon({
    className: 'cl-map-pin-icon',
    html: `<div class="cl-map-pin" style="--pin:${color ?? PIN_TONES[tone]}">${
      label != null && label !== '' ? `<span>${escapeHtml(label)}</span>` : '<i></i>'
    }</div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 36],
    popupAnchor: [0, -36],
  });

export const createClusterIcon = (count: number, color: string = PIN_TONES.emerald): L.DivIcon =>
  L.divIcon({
    className: 'cl-map-cluster-icon',
    html: `<div class="cl-map-cluster" style="--cl:${color}"><span>${count}</span></div>`,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
  });

/** The user's own location: a pulsing blue dot (styles `.cl-map-me`), centered on the coordinate. */
export const createLocationDotIcon = (): L.DivIcon =>
  L.divIcon({
    className: 'cl-map-me-icon',
    html: '<div class="cl-map-me"></div>',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  });
